import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import ReactHtmlParser from "react-html-parser";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Tooltip from "react-bootstrap/Tooltip";
import PhoneInput from "react-phone-input-2";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { userGroupUrlCheck } from "../../../utils/userGroupUrlCheck";
import { URL_IMG } from "../../../configs/urlConfigs";
import {
  LBL_CONFIRM_CATEGORY_CHANGE,
  LBL_CLEAR,
  LBL_VENUE_PROFILE,
  LBL_SELECT,
  LBL_TIME_ZONE,
  LBL_NOTES,
  LBL_DELETE,
  LBL_SAVE,
  LBL_CONFIRM_DELETION,
  LBL_CONFIRM_DEACTIVATION,
  LBL_ACTIVATE,
  LBL_DEACTIVATE,
  LBL_CONFIRM_ACTIVATION,
  LBL_SEL_CLIENT_CATEGORY,
  LBL_CLIENT_CATEGORY,
  LBL_DEPARTMENTS,
  LBL_PHYSICAL_ADDRESS,
  LBL_BILLING_ADDRESS,
  LBL_SAME_AS_PHYSICAL_ADDRESS,
} from "../../../configs/labelConfigs";
import {
  PHONE_ISD_CODE,
  PHONE_ISD_NUM,
  DISABLE_LOC_DET_EDIT,
  LOGIN_CLIENT_GROUP,
  LOGIN_SUPER_ADMIN_GROUP,
} from "../../../configs/staticConfigs";
import {
  MSG_CONFIRM_CLIENT_CATEGORY,
  MSG_REQUIRED,
  MSG_CONFIRM_CLIENT_DEACTIVATE_START,
  MSG_CONFIRM_CLIENT_DELETE_START,
  MSG_CONFIRM_CLIENT_DELETE_END,
  MSG_CONFIRM_CLIENT_ACTIVATE_START,
} from "../../../configs/msgConfigs";

import ModalWindow from "../../commons/helpers/modalWindow";
import CustomMultiSelect from "../../commons/helpers/customMultiSelect";
import LocationSearchInput from "../../commons/helpers/googleLocationSearch";

class CompanyInfo extends Component {
  constructor(props) {
    super();
    this.state = {
      activeDeactiveText: "",
      chkSendVerifyEmail: true,
      e: { target: { name: "category", type: "", value: "" } },
      initialValidation:false,
    };

    this.modalDelete = React.createRef();
    this.modalActivate = React.createRef();
    this.modalCategoryConf = React.createRef();
  }

  uploadLogoFile() {
    document.getElementById("uploadLogo").click();
  }

  renderTooltip(name, props) {
    return (
      <Tooltip
        id={name}
        style={{
          opacity: 0.4,
        }}
        {...props}
      >
        {name}
      </Tooltip>
    );
  }

  onClearClient = () => {
    this.clientTypeahead.clear();
    this.props.onClearClient();
  };
  onGetGoogleLocClick = (e,id) => {
    this.typeahead.clear();
    this.props.onGetGoogleLoc(e,id);
  };

  deactivateBtnClick = () => {
    this.modalDelete.current.handleOpenModal();
  };
  activateBtnClick = () => {
    this.modalActivate.current.handleOpenModal();
  };

  deleteBtnClick = () => {
    this.setState({ activeDeactiveText: LBL_DEACTIVATE }, () => {
      this.modalDelete.current.handleOpenModal();
    });
  };

  activateClick = () => {
    this.setState({ activeDeactiveText: LBL_ACTIVATE }, () => {
      this.modalActivate.current.handleOpenModal();
    });
  };

  onModalFormReset = () => {};

  onHandleCategoryChange = (e) => {
    let event = {
      target: { name: "category", type: "text", value: e.target.value },
    };
    this.setState({ e: event });
    if (parseInt(e.target.value, 10) === 0) {
      this.props.onHandleChange(
        { target: { name: "category", type: "text", value: e.target.value } },
        "category"
      );
    } else {
      this.modalCategoryConf.current.handleOpenModal();
    }
  };



  componentDidUpdate(prevProps) {
    const {
      clientActivatedSuccess,
      clientDeactivatedSuccess,
      categorySaveSuccess,
    } = this.props;
    if (
      clientActivatedSuccess &&
      Number(clientActivatedSuccess) > 0 &&
      Number(clientActivatedSuccess) > Number(prevProps.clientActivatedSuccess)
    ) {
      this.modalActivate.current.handleModelCloseOnly();
    }
    if (
      clientDeactivatedSuccess &&
      Number(clientDeactivatedSuccess) > 0 &&
      Number(clientDeactivatedSuccess) >
        Number(prevProps.clientDeactivatedSuccess)
    ) {
      this.modalDelete.current.handleModelCloseOnly();
    }
    if (categorySaveSuccess === true) {
      this.modalCategoryConf.current.handleModelCloseOnly();
      this.props.changeCategorySaveSuccess(false);
    }
  }

  render() {
    
    const {
      addNewButtonClicked,
      clientFullListData,
      clientCategoryBasicData,
      clientData,
      formErrors,
      imgUrl,
      signatureUrl,
      locations,
      totalEvent,
      totalShift,
      clientId,
      logoLabel,
      isLogoValid,
      timeZonesList,
      is_active,
      isSignatureValid,
      signatureLabel,
      userType,
      client_affiliate_status,
      deptMultiSelList,
    } = this.props; // sectors,subSectors,

    const { initialValidation } = this.state;

    let companyName = "";
    if (this.props.hasOwnProperty("showNameInHeader"))
      companyName = this.props.showNameInHeader;
    
    let logoUrl = require("../../../" + URL_IMG + "affiliate-profile-new.png");
    let signatureLogoUrl = require("../../../" + URL_IMG + "signature.png");
    if (imgUrl) {
      logoUrl = imgUrl;
    }
    if (signatureUrl) {
      signatureLogoUrl = signatureUrl;
    }

    let userGroupData = userGroupUrlCheck(window.location);
    let userGroup = "";
    let isClient = false;
    let isSuper = false;
    if (userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
      if (userGroup == LOGIN_CLIENT_GROUP) {
        isClient = true;
      } else if (userGroup == LOGIN_SUPER_ADMIN_GROUP) {
        isSuper = true;
      }
    }

    // let disableEditAddress =
    //   !DISABLE_LOC_DET_EDIT &&
    //   clientData.companyInfo.googleLocation &&
    //   clientData.companyInfo.googleLocation.length > 0 &&
    //   clientData.companyInfo.noLocationFound
    //     ? false
    //     : true;
    let disableEditAddress =
      !DISABLE_LOC_DET_EDIT &&
      clientData.companyInfo.googleLocation &&
      clientData.companyInfo.googleLocation.length > 0 &&
      clientData.companyInfo.noLocationFound
        ? false
        : false;
    return (
      <div className="form-group col-md-12">
        <Form
          onSubmit={(e) => {
            e.preventDefault(); // Prevent default form submission behavior
            this.setState({ initialValidation: true }, () => {
              this.props.saveFormData(e); // Call the parent saveFormData function
            });
          }}
          encType="multipart/form-data"
        >
          <div className="box margin-top-12">
            <div className="tab-head padding-right-50">
              {/* <h6>Basic Info {(companyName) && <span>{' - '+companyName}</span>} </h6> */}
              <h6>&nbsp;</h6>
              {!isSuper && (
                <button className="btn btn-primary float-right">
                  {LBL_SAVE}
                </button>
              )}
            </div>
            <div className="box-content">
              <Row>
                <div className="col-lg-4 col-xl-4 col-12">
                  <Row>
                    <div className="client-profile">
                      <div className="company-logo">
                        {isSuper && <img src={logoUrl} alt="Company Name" />}

                        {!isSuper && (
                          <>
                            <img
                              src={logoUrl}
                              alt="Company Name"
                              style={{ cursor: "pointer" }}
                              onClick={this.uploadLogoFile}
                            />
                            <p
                              className={
                                isLogoValid
                                  ? "logo-txt mb-0"
                                  : "text-red logo-txt"
                              }
                            >
                              <small>{logoLabel}</small>
                            </p>
                            <label htmlFor="uploadLogo">
                              <i className="las la-pen"></i>
                            </label>
                            <input
                              type="file"
                              id="uploadLogo"
                              name="logo"
                              onChange={this.props.onHandleChange}
                              accept=".jpeg, .jpg, .png, .gif"
                            />
                          </>
                        )}
                      </div>
                      {/* {clientId ? (
                                                <div className="row">
                                                    <div className="col-4">
                                                        {totalEvent!==''?(
                                                            <h4>Projects  <strong>{totalEvent}</strong></h4>                                                     
                                                        ):''}
                                                    </div>
                                                    <div className="col-4">
                                                        {totalShift!==''?(
                                                            <h4>Shifts<strong>{totalShift}</strong></h4>                                                    
                                                        ):''}                                                
                                                    </div>
                                                    <div className="col-4">
                                                        {totalShift!==''?(
                                                           <h4>Total Spent  <strong>£4523.00</strong></h4>                                                   
                                                        ):''}   
                                                                                                                  
                                                    </div>
                                                </div>    
                                                ) : ''
                                            }   */}
                    </div>
                  </Row>
                  {isClient ? (
                    <Row>
                      <div
                        className="client-profile"
                        style={{ width: "21.5em" }}
                      >
                        <label>Authorized Signatory For Quotes</label>
                        <div
                          className="company-logo"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <img src={signatureLogoUrl} alt="Signature" />
                          <p
                            className={
                              isSignatureValid
                                ? "logo-txt mb-0"
                                : "text-red logo-txt"
                            }
                          >
                            <small>{signatureLabel}</small>
                          </p>
                          <label htmlFor="uploadSignature">
                            <i className="las la-pen"></i>
                          </label>
                          <input
                            type="file"
                            id="uploadSignature"
                            name="signature"
                            onChange={this.props.onHandleChange}
                            accept=".jpeg, .jpg, .png, .gif"
                          />
                        </div>
                      </div>
                    </Row>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-8 col-xl-8 col-12 pl-0">
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Company Name</label>
                        {(addNewButtonClicked === 0 ||
                          clientId !== undefined) && (
                          <div className="text-input">
                            <input
                              type="text"
                              className={
                                (formErrors.companyName.length > 0 && initialValidation)
                                  ? "input-error"
                                  : ""
                              }
                              onChange={this.props.onHandleChange}
                              name="companyName"
                              value={clientData.companyInfo.companyName || ""}
                              tabIndex="1"
                              maxLength={120}
                            />
                          </div>
                        )}
                        {addNewButtonClicked === 1 &&
                          clientId === undefined && (
                            <div className="text-input">
                              <AsyncTypeahead
                                isLoading={false}
                                id="companyFilteredName"
                                minLength={0}
                                maxLength={120}
                                labelKey="client_name_with_register"
                                onChange={(selected) =>
                                  this.props.onSelectClientList(selected)
                                }
                                options={clientFullListData}
                                placeholder="Type a company name or reg.No ..."
                                onSearch={this.props.onClientSearch}
                                searchText="Searching"
                                promptText="Type a company name or reg.No ..."
                                disabled={this.props.filteredClient}
                                ref={(ref) => (this.clientTypeahead = ref)}
                                tabIndex="8"
                                onInputChange={(query) =>
                                  this.props.onClientInputChange(query)
                                }
                                // inputProps={{
                                //     tabIndex: '1'
                                //     }}
                                inputProps={{
                                  tabIndex: "1",
                                  name: "companyFilteredName",
                                  className:
                                    (formErrors.companyName.length > 0 && initialValidation)
                                      ? "input-error"
                                      : "",
                                }}
                              />
                              {this.props.filteredClient && (
                                <div className="text-12 paddingTop4">
                                  &nbsp; &nbsp; &nbsp;{" "}
                                  <Link
                                    to="#"
                                    className={
                                      !this.props.filteredClient
                                        ? "clearBtnDisabled floatRight"
                                        : "floatRight"
                                    }
                                    onClick={
                                      this.props.filteredClient
                                        ? this.onClearClient
                                        : ""
                                    }
                                  >
                                    {LBL_CLEAR}
                                  </Link>
                                </div>
                              )}
                            </div>
                          )}
                        {formErrors.companyName.length > 0 &&
                          formErrors.companyName !== MSG_REQUIRED && (
                            <div className="text-red left-align text-12">
                              {formErrors.companyName}
                            </div>
                          )}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Company email address</label>
                        <div className="input email-input">
                          <input
                            type="email"
                            className={
                              (formErrors.companyEmail.length > 0 && initialValidation)
                                ? "input-error"
                                : ""
                            }
                            onChange={this.props.onHandleChange}
                            name="companyEmail"
                            value={clientData.companyInfo.companyEmail || ""}
                            tabIndex="2"
                            maxLength={120}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Company contact number</label>
                        <PhoneInput
                          country={PHONE_ISD_CODE}
                          inputProps={{
                            name: "companyContactNum",
                            tabIndex: "3",
                          }}
                          value={
                            clientData.companyInfo.companyContactNum ||
                            PHONE_ISD_NUM
                          }
                          onChange={this.props.onPhoneInputChange}
                        />
                      </div>
                    </Col>
                    {/* <Col md={6}>
                                            <div className="form-group">
                                                <label>Website</label>
                                                <div className="input weburl-input">
                                                    <input type="text" onChange={this.props.onHandleChange} name="websiteUrl" value={clientData.companyInfo.websiteUrl || ''} autoComplete="off" tabIndex="4" maxLength={120} />
                                                </div>
                                            </div>
                                        </Col>*/}
                    <Col md={6}>
                      {!isClient ? (
                        <div className="form-group">
                          <label>{LBL_CLIENT_CATEGORY}</label>
                          <div>
                            <div className="form-group select-input">
                              <select
                                name="category"
                                onChange={this.props.onHandleChange}
                                value={clientData.companyInfo.category || "0"}
                                className={
                                  (formErrors.category &&
                                  formErrors.category.length > 0 && initialValidation)
                                    ? "input-error pay-level height-32"
                                    : "pay-level height-32"
                                }
                                tabIndex="1"
                                disabled={isSuper}
                              >
                                <option key="0" value="0">
                                  {LBL_SEL_CLIENT_CATEGORY}
                                </option>
                                {Array.isArray(clientCategoryBasicData) &&
                                  clientCategoryBasicData.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>

                 {/* <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>Company registration number</label>
                                                <div className="input-input"><input type="text" onChange={this.props.onHandleChange} name="companyRegNum" value={clientData.companyInfo.companyRegNum || ''}  tabIndex="5"  maxLength={120} /></div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>VAT Number</label>
                                                <div className="input-input"><input type="text" onChange={this.props.onHandleChange} name="vatNum" value={clientData.companyInfo.vatNum || ''}  tabIndex="6"  maxLength={120} /></div>
                                            </div>
                                        </Col>
                                    </Row> */}





                                    <Row>
                                        <Col md={6}>
                                            {/* { !isClient ? ( */}
                                            <div className="form-group">
                                                <label>{LBL_DEPARTMENTS}</label>
                                                <div className="form-group multisel_textbox">
                                                        <div className="form-group select-input skills" >
                                                        <CustomMultiSelect id={'dept'} data={deptMultiSelList} trimString='yes'  onChange={selected =>this.props.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex:"10" }} tabIndex="10" classValue={(formErrors.departments.length >0 && initialValidation) ? "input-error" : ''} needSelectAll="yes" />
                                                        </div>
                                                </div>  
                                            </div>
                                            {/* ) : (<div></div>) } */}
                                        </Col>
                                        {/* <Col md={6}>
                                            { !isClient ? (
                                            <div className="form-group">
                                                <label>{LBL_CLIENT_CATEGORY}</label>
                                                <div>    
                                                    <div className="form-group select-input">
                                                    <select name="category" onChange={this.props.onHandleChange} value={clientData.companyInfo.category||'0'} className={formErrors.category && formErrors.category.length >0 ? "input-error pay-level height-32" : 'pay-level height-32'}  tabIndex="1" disabled={isSuper} >
                                                    <option key="0" value="0">{LBL_SEL_CLIENT_CATEGORY}</option>
                                                    {Array.isArray(clientCategoryBasicData) && clientCategoryBasicData.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)} 
                                                </select>
                                                    </div> 
                                                </div> 
            
                                            </div>
                                        ): ""
                                        }
                                        </Col> */}
                                    </Row> 
                  <Row>
                    <Col md={12} className="mt-2">
                      {LBL_PHYSICAL_ADDRESS}
                      <hr className="mt-0" />
                    </Col>
                  </Row>
                  <Row>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Location</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="custom-checkbox d-flex ">
                          <input
                            type="checkbox"
                            id="noLocationFound"
                            name="noLocationFound"
                            onChange={(e)=>this.onGetGoogleLocClick(e,"noLocationFound")}
                            checked={clientData.companyInfo.noLocationFound ? clientData.companyInfo.noLocationFound : false}
                            tabIndex="7"
                          />
                          <label
                            className="checkbox"
                            htmlFor="noLocationFound"
                            tabIndex="7"
                          ></label>
                          <label
                            className="labeltext mt-1"
                            htmlFor="noLocationFound"
                          >
                            Couldn't find the location? Get it from Google
                            <sup>
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderTooltip(
                                  "Type address to get the location from google map"
                                )}
                              >
                                <button type="button" className="tootltip-btn">
                                  <i className="las la-question-circle"></i>
                                </button>
                              </OverlayTrigger>
                            </sup>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <div
                          className={
                            clientData.companyInfo.noLocationFound
                              ? "hide"
                              : "text-input"
                          }
                        >
                          <AsyncTypeahead
                            isLoading={false}
                            name="location"
                            id="locationSearch"
                            minLength={3}
                            labelKey="location"
                            onChange={(selected) =>
                              this.props.onSelectLocation(selected,"locationSearch")
                            }
                            options={locations}
                            placeholder="Type a location..."
                            onSearch={this.props.onsearchLocation}
                            searchText="Searching"
                            promptText="Type a location..."
                            disabled={this.props.disableLocationSearch}
                            ref={(ref) => (this.typeahead = ref)}
                            tabIndex="8"
                            inputProps={{
                              tabIndex: "8",
                              className:
                                (formErrors.location &&
                                formErrors.location.length > 0 && initialValidation)
                                  ? "input-error"
                                  : "",
                            }}
                          />
                        </div>
                        <div
                          className={
                            clientData.companyInfo.noLocationFound
                              ? "text-input"
                              : "hide"
                          }
                        >
                          <LocationSearchInput
                            name="googleLocation"
                            googleLocSelect={(address)=>this.props.googleLocSelect(address,"googleLocation")}
                            disabled={this.props.disableLocationSearch}
                            tabIndex="9"
                            className={
                              (formErrors.location &&
                              formErrors.location.length > 0 && initialValidation)
                                ? " input-error"
                                : ""
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label>{LBL_VENUE_PROFILE}</label>
                        <div
                          className={
                            disableEditAddress
                              ? "text-input text-optional"
                              : "text-input"
                          }
                        >
                          <input
                            type="text"
                            placeholder={LBL_VENUE_PROFILE}
                            name="venue"
                            onChange={this.props.onHandleChange}
                            value={clientData.companyInfo.venue || ""}
                            maxLength={125}
                            tabIndex="10"
                            disabled={disableEditAddress}
                          />
                          {/* disabled={!clientData.companyInfo.noLocationFound}  */}
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">&nbsp;</div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Street 1</label>
                        <div
                          className={
                            disableEditAddress
                              ? "text-input text-optional"
                              : "text-input"
                          }
                        >
                          <input
                            type="text"
                            name="streetOne"
                            onChange={this.props.onHandleChange}
                            value={clientData.companyInfo.streetOne || ""}
                            disabled={disableEditAddress}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Street 2</label>
                        <div
                          className={
                            disableEditAddress
                              ? "text-input text-optional"
                              : "text-input"
                          }
                        >
                          <input
                            type="text"
                            name="streetTwo"
                            onChange={this.props.onHandleChange}
                            value={clientData.companyInfo.streetTwo || ""}
                            disabled={disableEditAddress}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label>City</label>
                        <div
                          className={
                            disableEditAddress
                              ? "text-input text-optional"
                              : "text-input"
                          }
                        >
                          <input
                            type="text"
                            name="city"
                            onChange={this.props.onHandleChange}
                            className={
                              (formErrors.city.length > 0  && initialValidation)? "input-error" : ""
                            }
                            value={clientData.companyInfo.city || ""}
                            disabled={disableEditAddress}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label>State</label>
                        <div
                          className={
                            disableEditAddress
                              ? "text-input text-optional"
                              : "text-input"
                          }
                        >
                          <input
                            type="text"
                            name="state"
                            onChange={this.props.onHandleChange}
                            className={
                              (formErrors.state.length > 0  && initialValidation)? "input-error" : ""
                            }
                            value={clientData.companyInfo.state || ""}
                            disabled={disableEditAddress}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Country</label>
                        <div
                          className={
                            disableEditAddress
                              ? "text-input text-optional"
                              : "text-input"
                          }
                        >
                          <input
                            type="text"
                            name="country"
                            onChange={this.props.onHandleChange}
                            className={
                              (formErrors.country.length > 0 && initialValidation) ? "input-error" : ""
                            }
                            value={clientData.companyInfo.country || ""}
                            disabled={disableEditAddress}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Post Code</label>
                        <div
                          className={
                            disableEditAddress
                              ? "text-input text-optional"
                              : "text-input"
                          }
                        >
                          <input
                            type="text"
                            name="postcode"
                            onChange={this.props.onHandleChange}
                            className={
                             ( formErrors.postcode.length > 0 && initialValidation)
                                ? "input-error"
                                : ""
                            }
                            value={clientData.companyInfo.postcode || ""}
                            disabled={disableEditAddress}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                      <Col md={12} >
                      <div className="form-group">
                          <div className="custom-checkbox">
                            <input
                              type="checkbox"
                              id="samePhysicalAddress"
                              name="samePhysicalAddress"
                              onChange={this.props.onHandleChange}
                              checked={clientData.companyInfo.samePhysicalAddress ? clientData.companyInfo.samePhysicalAddress : false}
                              tabIndex="8"
                            />
                            <label
                              className="checkbox"
                              htmlFor="samePhysicalAddress"
                              tabIndex="8"
                            ></label>
                            <label
                              className="labeltext"
                              htmlFor="samePhysicalAddress"
                            >
                              {LBL_SAME_AS_PHYSICAL_ADDRESS}
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>

                  {(!clientData.companyInfo.samePhysicalAddress)&&<>
                    <Row>
                      <Col md={12} className="mt-2">
                        {LBL_BILLING_ADDRESS}
                        <hr className="mt-0" />
                      </Col>
                    </Row>
                    <Row>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Location</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="custom-checkbox">
                            <input
                              type="checkbox"
                              id="noLocationFoundBilling"
                              name="noLocationFoundBilling"
                              onChange={(e)=>this.onGetGoogleLocClick(e,"noLocationFoundBilling")}
                              checked={clientData.companyInfo.noLocationFoundBilling ? clientData.companyInfo.noLocationFoundBilling : false}
                              tabIndex="9"
                            />
                            <label
                              className="checkbox"
                              htmlFor="noLocationFoundBilling"
                              tabIndex="9"
                            ></label>
                            <label
                              className="labeltext"
                              htmlFor="noLocationFoundBilling"
                            >
                              Couldn't find the location? Get it from Google
                              <sup>
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={this.renderTooltip(
                                    "Type address to get the location from google map"
                                  )}
                                >
                                  <button
                                    type="button"
                                    className="tootltip-btn"
                                  >
                                    <i className="las la-question-circle"></i>
                                  </button>
                                </OverlayTrigger>
                              </sup>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div
                            className={
                              clientData.companyInfo.noLocationFoundBilling
                                ? "hide"
                                : "text-input"
                            }
                          >
                            <AsyncTypeahead
                              isLoading={false}
                              name="location"
                              id="locationSearchBilling"
                              minLength={3}
                              labelKey="location"
                              onChange={(selected) =>
                                this.props.onSelectLocation(selected,"locationSearchBilling")
                              }
                              options={locations}
                              placeholder="Type a location..."
                              onSearch={this.props.onsearchLocation}
                              searchText="Searching"
                              promptText="Type a location..."
                              disabled={this.props.disableLocationSearch}
                              ref={(ref) => (this.typeahead = ref)}
                              tabIndex="8"
                              inputProps={{
                                tabIndex: "8",
                                className:
                                  (formErrors.locationBilling &&
                                  formErrors.locationBilling.length > 0 && initialValidation)
                                    ? "input-error"
                                    : "",
                              }}
                            />
                          </div>
                          <div
                            className={
                              clientData.companyInfo.noLocationFoundBilling
                                ? "text-input"
                                : "hide"
                            }
                          >
                            <LocationSearchInput
                              name="googleLocationBilling"
                            googleLocSelect={(address)=>this.props.googleLocSelect(address,"googleLocationBilling")}
                              disabled={this.props.disableLocationSearch}
                              tabIndex="9"
                              className={
                                (formErrors.location &&
                                formErrors.location.length > 0 && initialValidation)
                                  ? " input-error"
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div className="form-group">
                          <label>{LBL_VENUE_PROFILE}</label>
                          <div
                            className={
                              disableEditAddress
                                ? "text-input text-optional"
                                : "text-input"
                            }
                          >
                            <input
                              type="text"
                              placeholder={LBL_VENUE_PROFILE}
                              name="venueBilling"
                              onChange={this.props.onHandleChange}
                              value={clientData.companyInfo.venueBilling || ""}
                              maxLength={125}
                              tabIndex="10"
                              disabled={disableEditAddress}
                            />
                            {/* disabled={!clientData.companyInfo.noLocationFound}  */}
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group">&nbsp;</div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <div className="form-group">
                          <label>Street 1</label>
                          <div
                            className={
                              disableEditAddress
                                ? "text-input text-optional"
                                : "text-input"
                            }
                          >
                            <input
                              type="text"
                              name="streetOneBilling"
                              onChange={this.props.onHandleChange}
                              value={clientData.companyInfo.streetOneBilling || ""}
                              disabled={disableEditAddress}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group">
                          <label>Street 2</label>
                          <div
                            className={
                              disableEditAddress
                                ? "text-input text-optional"
                                : "text-input"
                            }
                          >
                            <input
                              type="text"
                              name="streetTwoBilling"
                              onChange={this.props.onHandleChange}
                              value={clientData.companyInfo.streetTwoBilling || ""}
                              disabled={disableEditAddress}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div className="form-group">
                          <label>City</label>
                          <div
                            className={
                              disableEditAddress
                                ? "text-input text-optional"
                                : "text-input"
                            }
                          >
                            <input
                              type="text"
                              name="cityBilling"
                              onChange={this.props.onHandleChange}
                              className={
                                (formErrors.cityBilling.length > 0 && initialValidation) ? "input-error" : ""
                              }
                              value={clientData.companyInfo.cityBilling || ""}
                              disabled={disableEditAddress}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group">
                          <label>State</label>
                          <div
                            className={
                              disableEditAddress
                                ? "text-input text-optional"
                                : "text-input"
                            }
                          >
                            <input
                              type="text"
                              name="stateBilling"
                              onChange={this.props.onHandleChange}
                              className={
                                (formErrors.stateBilling.length > 0 && initialValidation) ? "input-error" : ""
                              }
                              value={clientData.companyInfo.stateBilling || ""}
                              disabled={disableEditAddress}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div className="form-group">
                          <label>Country</label>
                          <div
                            className={
                              disableEditAddress
                                ? "text-input text-optional"
                                : "text-input"
                            }
                          >
                            <input
                              type="text"
                              name="countryBilling"
                              onChange={this.props.onHandleChange}
                              className={
                                (formErrors.countryBilling.length && initialValidation) > 0
                                  ? "input-error"
                                  : ""
                              }
                              value={clientData.companyInfo.countryBilling || ""}
                              disabled={disableEditAddress}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group">
                          <label>Post Code</label>
                          <div
                            className={
                              disableEditAddress
                                ? "text-input text-optional"
                                : "text-input"
                            }
                          >
                            <input
                              type="text"
                              name="postcodeBilling"
                              onChange={this.props.onHandleChange}
                              className={
                                (formErrors.postcodeBilling.length >0  && initialValidation)
                                  ? "input-error"
                                  : ""
                              }
                              value={clientData.companyInfo.postcodeBilling || ""}
                              disabled={disableEditAddress}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>}

                  {/* <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_TIME_ZONE} </label>
                                                <div className="form-group select-input">
                                                    <select name="timeZone" onChange={this.props.onHandleChange} value={clientData.companyInfo.timeZone} className={formErrors.timeZone.length >0 ? "input-error" : ''} tabIndex="12">
                                                        <option value=''>{LBL_SELECT+' '+LBL_TIME_ZONE}</option>
                                                        {timeZonesList.map((item) => <option key={item.id} value={item.id}>{item.region}</option>)}  
                                                    </select>
                                                </div>
                                            </div>
                                        </Col>   
                                    </Row>  
                                    <Row>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>{LBL_NOTES}</label>
                                                <div className="input-input"><textarea name="additionalText" onChange={this.props.onHandleChange} value={clientData.companyInfo.additionalText || ''}
                                                        className="form-control" tabIndex="13"></textarea></div>
                                            </div>
                                        </div>
                                    </Row> */}
                  <div className="clearfix padding-right-15">
                    {!isSuper && (
                      <button
                        className="btn btn-primary float-right"
                        tabIndex="15"
                      >
                        {LBL_SAVE}
                      </button>
                    )}
                    {clientId && is_active && isSuper && !isClient ? (
                      <Link
                        onClick={this.deactivateBtnClick}
                        className="text-danger mt-1 float-left"
                        to="#"
                        tabIndex="14"
                      >
                        <u>{isSuper ? LBL_DELETE : LBL_DEACTIVATE}</u>
                      </Link>
                    ) : (
                      ""
                    )}
                    {clientId &&
                    client_affiliate_status &&
                    !isSuper &&
                    !isClient ? (
                      <Link
                        onClick={this.deactivateBtnClick}
                        className="text-danger mt-1 float-left"
                        to="#"
                        tabIndex="14"
                      >
                        <u>{isSuper ? LBL_DELETE : LBL_DEACTIVATE}</u>
                      </Link>
                    ) : (
                      ""
                    )}
                    {clientId &&
                    !client_affiliate_status &&
                    !isSuper &&
                    !isClient ? (
                      <Link
                        onClick={this.activateBtnClick}
                        className="text-danger mt-1 float-left"
                        to="#"
                      >
                        <u>{LBL_ACTIVATE}</u>
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="padding-top-50">&nbsp;</div>
              </Row>
              <div className="padding-top-50">&nbsp;</div>
            </div>
          </div>

          <ModalWindow
            ref={this.modalDelete}
            header={isSuper ? LBL_CONFIRM_DELETION : LBL_CONFIRM_DEACTIVATION}
            type={isSuper ? "delete" : "confirm"}
            deleteConfirmedItem={this.props.deactivateUser}
            deleteItem={this.props.deactivateUser}
            resetModalForm={this.onModalFormReset}
          >
            {isSuper
              ? MSG_CONFIRM_CLIENT_DELETE_START +
                " '" +
                clientData.companyInfo.companyName +
                "'? " +
                MSG_CONFIRM_CLIENT_DELETE_END
              : MSG_CONFIRM_CLIENT_DEACTIVATE_START +
                " '" +
                clientData.companyInfo.companyName +
                "'? "}
          </ModalWindow>

          <ModalWindow
            ref={this.modalActivate}
            header={LBL_CONFIRM_ACTIVATION}
            type="confirm"
            deleteConfirmedItem={this.props.activateUser}
            resetModalForm={this.onModalFormReset}
          >
            {MSG_CONFIRM_CLIENT_ACTIVATE_START +
              " '" +
              clientData.companyInfo.companyName +
              "'? "}
          </ModalWindow>
          <ModalWindow
            ref={this.modalCategoryConf}
            header={LBL_CONFIRM_CATEGORY_CHANGE}
            type="confirm"
            deleteConfirmedItem={(e) =>
              this.props.onHandleChange(this.state.e, "category")
            }
            resetModalForm={this.onModalFormReset}
          >
            {MSG_CONFIRM_CLIENT_CATEGORY + "? "}
          </ModalWindow>
        </Form>
      </div>
    );
  }
}

export default CompanyInfo;
